
<template>
  <div class="whatif">

    <span class="adjust-section-title section-title">
      What if I...
    </span>

    <div class="adjust-actions">
      <a @click="resetWhatIfValues" class="pl-1">Reset </a>
      <span style="color: #aaa">|</span>
              
      <a @click="okSelected()" class="pr-1 pl-1">OK</a>
    </div>

    <v-layout row pt-3>

      <delta-adjustment
        ident="distributionCenterCount"
        title="CHANGE # OF DISTRIBUTION CENTERS"
        :fixed-precision=0
        :value=0
        :min=-5
        :max=5
        :step=1        
        v-on:value-changed="distributionCenterCountDidChange"
        ref="distributionCenterCountAdjuster"
      ></delta-adjustment>

      <div class="vertical-separator"></div>

      <delta-adjustment
        ident="laborCosts"
        title="CHANGE LABOR COSTS"
        unit="%"
        :fixed-precision=2
        :value=0
        :min=-50.0
        :max=50.0
        :step=0.25
        v-on:value-changed="laborCostDidChange"
        ref="laborCostsAdjuster"
      ></delta-adjustment>

      <div class="vertical-separator"></div>

      <delta-adjustment
        ident="leaseCosts"
        title="CHANGE LEASE COSTS"
        unit="%"
        :fixed-precision=2
        :value=0
        :min=-50.0
        :max=50.0
        :step=0.25
        v-on:value-changed="leaseCostDidChange"
        ref="leaseCostsAdjuster"
      ></delta-adjustment>


    </v-layout>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'whatif-adjuster',
  data () {
    return {
      marketsAtInit: undefined
    }
  },

  methods: {
    okSelected() {
      this.$store.commit('setLeaseCostAdjuster', 1.0)
      this.$store.commit('setLaborCostAdjuster', 1.0)
      this.$store.commit('setNetworkAnalysisBaseServiceRanges', {})

      if(this.marketsAtInit != undefined) {
        this.$store.commit('setMarkets', this.marketsAtInit)
        this.$store.commit('setDistributionCenterCount', this.marketsAtInit.length)
        this.$store.commit('setDistributionCenterCountAdjuster', 0)
        this.maketsAtInit = undefined
      }

      this.$emit("did-close")
    },
    distributionCenterCountDidChange(ev) {
      if(this.marketsAtInit == undefined) {
        this.marketsAtInit = _.cloneDeep(this.markets)
        this.$store.commit('setNetworkAnalysisBaseServiceRanges', _.cloneDeep(this.$store.getters.networkAnalysisServiceRanges))
        this.$store.commit('setDistributionCenterCountAdjuster', this.markets.length)
      }

      let v = Math.min(Math.max(this.marketsAtInit.length + parseInt(ev.val), 1), 20)

      if(!this.$store.getters.naMarketManuallySpecified){
        let marketIds = this.$store.getters.defaultMarkets[v]
        let theMarkets = _.filter(this.$store.getters.availableMarkets, o => {
          return _.includes(marketIds, o.id)
        })

        this.$store.commit('setMarkets', theMarkets)
      } else if(parseInt(ev.val) == 0){
        this.$store.commit('setMarkets', _.cloneDeep(this.marketsAtInit))
      } else {
        let currentDelta = this.markets.length - this.marketsAtInit.length
        let newDelta = parseInt(ev.val)

        if(currentDelta < newDelta){ // if number of DCs increased
          this.$store.dispatch('findCheapestMarkets', Math.abs(newDelta - currentDelta))
        } else if(currentDelta > newDelta) { // if number of DCs decreased
          this.$store.dispatch('findHighestDemandMarkets', Math.abs(currentDelta - newDelta))
        }
      }

      this.$store.commit('setDistributionCenterCount', v)
    },
    leaseCostDidChange(ev) {
      this.$store.commit('setLeaseCostAdjuster', 1 + (ev.val / 100))
    },
    laborCostDidChange(ev) {
      this.$store.commit('setLaborCostAdjuster', 1 + (ev.val / 100))
    },
    resetWhatIfValues() {
      this.$refs.distributionCenterCountAdjuster.enteredValueDidChange(0)
      this.$refs.leaseCostsAdjuster.enteredValueDidChange(0)
      this.$refs.laborCostsAdjuster.enteredValueDidChange(0)
    }
  },

  computed: {
    annualRevenue() {
      return this.$store.getters.annualRevenue
    },
    distributionCenterCount() {
      return this.$store.getters.distributionCenterCount
    },
    totalSquareFootage() {
      return this.$store.getters.totalSquareFootage
    },
    markets() {
      return this.$store.getters.markets
    }
  },

components: {
    'delta-adjustment': () => import ('@/components/DeltaAdjustment'),
  }
}

</script>


<style scoped>
a:hover {
  font-weight: bold;
}

.whatif {
  background-color: #FFFEED;
  height: 100%;
}
.adjust-actions {
  display: inline-block;
  font-size: 10pt;
  position: absolute;
  right: 180px;
  top: 5px;
}
.section-title {
  text-align: left;
  padding-left: 10px;
  color: #444;
}
.adjust-section-title {
  font-weight: bold;
  font-size: 13pt;
}
.vertical-separator {
  width: 1px;
  height: 35px;
  background-color: #ccc;
  position: relative;
  top: 35px;
}


@media only screen and (max-width: 600px) {
  .adjust-actions {
    right: 5px;
  }
}

@media only screen and (max-height: 550px) {
  .adjust-actions {
    right: 5px;
  }
}

</style>